// Define public jQuery
window.$ = window.jQuery = require('jquery')

// Extends Javascript properties
// require('js.extend')

// Conditionizr
// require('./main/conditionizr')

require('swiper')
require('./bootstrap.min.js')
require('./ie10-viewport-bug-workaround.js')
require('./jquery.fancybox.min.js')
require('./jquery.waypoints.min.js')
require('./scripts.js')
